import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type Behavior = {
  inventory_id?: number
}

export type BehaviorState = Behavior | null

const initialState = null as BehaviorState

const behaviorSlice = createSlice({
  name: 'behavior',
  initialState,
  reducers: {
    setBehavior: (_state, action: PayloadAction<Behavior>) => action.payload,
    getBehavior: (state) => state
  }
})

export const { setBehavior, getBehavior } = behaviorSlice.actions
export default behaviorSlice.reducer
